module.exports = __webpack_public_path__ + "img/Roboto-Regular-webfont.1d45bc40.svg";